import { render, staticRenderFns } from "./wrapperPRODraft.vue?vue&type=template&id=4090369d&"
import script from "./wrapperPRODraft.vue?vue&type=script&lang=js&"
export * from "./wrapperPRODraft.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports